const list = {
    or: 'nebo',
    and: 'a',
    separator: ',',
};
export default Object.freeze(list);
